import {connect} from "react-redux";
import React from "react";
import '../styles/topbar.scss';
import {WavingTriangle} from "./WavingTriangle";
import {setView} from "../actions";
import {Button} from "./icymat-design/Button";


class TopbarClass extends React.Component {
    constructor(props) {
        super(props);

        this.classLoading = 0;
        this.lastScreen = 'main';
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.view !== this.lastScreen) {
            this.lastScreen = this.props.view;
        }
    }

    getTopbarClass = () => {
        if (this.classLoading++ < 8) {
            return '';
        }

        return this.props.view === 'main' ? 'inactive' : 'active';
    }

    getActionActiveClass = () => {
        if (this.classLoading++ < 8) {
            return '';
        }

        let actionClass = 'inactive';
        if (this.props.topbar?.action1 !== null || this.props.topbar?.action2 !== null) {
            actionClass = 'active';
        }

        return actionClass;
    }

    getActionBigClass = () => {
        if (this.classLoading++ < 8) {
            return '';
        }

        let actionClass = 'inactive';
        if (this.props.topbar?.action1 === null && this.props.topbar?.action2 === null && this.props.topbar?.actionBig !== null) {
            actionClass = 'active';
        }

        return actionClass;
    }

    generateSection = (section) => {
        if (this.props.topbar[section] === null) {
            return null;
        }

        if (Array.isArray(this.props.topbar[section])) {
            let elements = [];

            this.props.topbar[section].forEach(function (element, key) {
                if (element.type === 'text') {
                    elements.push(<span key={section + '-' + key} className={'imd-text-' + element.color}>{element.text}</span>);
                } else if (element.type === 'button') {
                    elements.push(
                        <Button
                            key={section + '-' + key}
                            icon={element?.icon}
                            text={element?.text}
                            color={element?.color}
                            secondary={element?.secondary}
                            onClick={() => element?.onClick()}
                        />
                    );
                }
            });

            return elements;
        }

        return this.props.topbar[section];
    }

    render() {
        if (this.props.flags?.topbar !== true) {
            return (<div id={'topbar'} style={{display: 'none'}} />);
        }

        return (
            <div
                id={'topbar'}
                // style={{display: this.props.view !== 'main' ? 'flex' : 'none'}}
                className={'imd-bg-blur-120-gray imd-border-color-default imd-text-white imd-shadow-bottom topbar-screen-' + this.props.view + ' ' + this.getTopbarClass()}
            >
                <div className={'action small left ' + this.getActionActiveClass()}>
                    {this.generateSection('action1')}
                </div>

                <div className={'triangle'}>
                    <WavingTriangle size={30} onClick={() => this.props.setView('main')} />
                </div>

                <div className={'action small right ' + this.getActionActiveClass()}>
                    {this.generateSection('action2')}
                </div>

                <div className={'action big right ' + this.getActionBigClass()}>
                    {this.generateSection('actionBig')}
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user,
        view: state.view,
        fingerprint: state.fingerprint,
        topbar: state.topbar,
        flags: state.user?.flags
    }
};

export const Topbar = connect(mapStateToProps, { setView })(TopbarClass);